import {
  BusinessEntity,
  BusinessEntityResponse,
} from '../../models/business-entity.model';
import { Region } from '../../models/region.model';

export function mapBusinessEntityResponseToModel(
  response: BusinessEntityResponse,
  regions: Region[],
): BusinessEntity {
  return {
    code: response.code,
    name: response.name,
    region: getRegion(response.region_id, regions) as Region,
    createdOn: new Date(response.created_on),
    updatedOn: new Date(response.updated_on),
  };
}

export function getRegion(regionId: number, regions: Region[]) {
  return regions.find((r) => r.id === regionId);
}
